import { differenceInDays } from 'date-fns'
import { useEffect, useRef, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { getProfile } from '../../api/auth'
import { getOrderDetail, getReviewable } from '../../api/orderHistory'
import { deleteProductReviews, deleteRecommend, getMyReview, getReviewDetail, postRecommend } from '../../api/product'
import { BtnMore, BtnReviewdLike, Button } from '../../components/Button'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { IconLiked } from '../../components/svg/IconSvg'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/myshopping.css'

// 이미지 경로
const imgURL = '/images'

export default function WrittenReviewList() {
  const { setIsLottie, hasAccessToken } = useCommonContext()
  const navigate = useNavigate()
  // 더보기 버튼 클릭시 상세 리뷰 내용 노출

  const [popup, setPopup] = useState<boolean>(true)
  const [confirmItem, setConfirmItem] = useState([])
  const [items, setItems] = useState([])
  const [myreviewItem, setMyreviewItem] = useState([])
  const [nickName, setNickName] = useState<string>('')
  const [changeRecommend, setChangeRecommend] = useState<boolean>(false)

  const content: string = 'after'

  useEffect(() => {
    // 하단 fixed버튼이 있다면 푸터를 밀어내야함
    const footer = document.querySelector('.footer_wrap') as HTMLElement
    if (footer) {
      isMobile ? (footer.style.paddingBottom = '36px') : (footer.style.paddingBottom = '0')
    }
  }, [])

  useEffect(() => {
    window.addEventListener('onFocus', () => {
      getReviewable()
        .then((res) => {
          setItems(res.data.items)
        })
        .catch((err) => console.log(err))
    })
    getReviewable()
      .then((res) => {
        setItems(res.data.items)
      })
      .catch((err) => console.log(err))
  }, [changeRecommend, location.pathname])

  useEffect(() => {
    const filterItem = items.filter((item: any) => {
      return item.orderStatusDate.reviewableYmdt !== null
    })
    setConfirmItem(filterItem)
  }, [items])

  useEffect(() => {
    if (hasAccessToken) {
      window.addEventListener('onFocus', () => {
        getMyReview()
          .then((res) => {
            setMyreviewItem(res.data.items)
            setIsLottie(false)
          })
          .catch((err) => console.log(err))
      })
      getMyReview()
        .then((res) => {
          setMyreviewItem(res.data.items)
          setIsLottie(false)
        })
        .catch((err) => console.log(err))
    }
  }, [changeRecommend, location.pathname])

  useEffect(() => {
    getProfile()
      .then((res) => {
        setIsLottie(false)
        setNickName(res.data.nickname)
      })
      .catch((err) => console.log(err))
  }, [])

  useEffect(() => {
    setTimeout(() => {
      setIsLottie(false)
    }, 500)
  }, [])

  // 작성 대기 중이거나 작성한 리뷰가 없을 때 박스 높이 조절
  useEffect(() => {
    const contentsWrap = document.querySelector('.contents_wrap')
    items?.length === 0 ? contentsWrap?.classList.add('full') : contentsWrap?.classList.remove('full')
  }, [])

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>상품 리뷰</PageTitle>
            {popup && confirmItem.length !== 0 && content !== 'after' ? (
              <div className='noti_pop'>
                <div>
                  <strong>리뷰 작성하고 최대 1000P 받아가세요</strong>
                  <p>(일반 리뷰 500P, 포토 리뷰 1000P)</p>
                </div>
                <button
                  type='button'
                  onClick={() => {
                    setPopup(false)
                  }}
                >
                  <img src={`${imgURL}/icon_w_close.png`} alt='' />
                </button>
              </div>
            ) : null}
            <TabWrap>
              <Tab
                className={content === 'before' ? 'on' : ''}
                onClick={() => {
                  navigate('/reviewlist/prepare')
                }}
              >
                작성 대기 중 {confirmItem.length !== 0 && <span>{confirmItem.length}</span>}
              </Tab>
              <Tab className={content === 'after' ? 'on' : ''} onClick={() => {}}>
                작성한 리뷰
                {myreviewItem.length !== 0 && <span>{myreviewItem.length}</span>}
              </Tab>
            </TabWrap>

            {/* 작성 대기 중 리스트 */}
            {content === 'before' ? (
              <ReviewBefore>
                <div className='review_info'>
                  <p>리뷰는 구매확정 후 90일까지 작성할 수 있습니다.</p>
                </div>
                <hr />
                {items.length === 0 ? (
                  <NoContentWrap>
                    <NoContentCotentWrap2>
                      <img src='/images/empty_logo.png' alt='' />
                      <NoContentContent>작성 대기 중인 리뷰가 없습니다.</NoContentContent>
                    </NoContentCotentWrap2>
                  </NoContentWrap>
                ) : (
                  items?.map((el: any, idx: number) => {
                    return <ReviewItem el={el} key={el.productNo} items={items} idx={idx}></ReviewItem>
                  })
                )}
              </ReviewBefore>
            ) : null}

            {/* 작성한 리뷰 리스트 */}
            {content === 'after' ? (
              <ReviewAfter>
                {myreviewItem.length === 0 ? (
                  <NoContentWrap>
                    <NoContentCotentWrap2>
                      <img src='/images/empty_logo.png' alt='' />
                      <NoContentContent>작성한 리뷰가 없습니다.</NoContentContent>
                    </NoContentCotentWrap2>
                  </NoContentWrap>
                ) : (
                  myreviewItem.map((el: any, idx: number) => {
                    return (
                      <MyReviewItem
                        key={idx}
                        el={el}
                        nickName={nickName}
                        idx={idx}
                        item={myreviewItem}
                        setChangeRecommend={setChangeRecommend}
                      ></MyReviewItem>
                    )
                  })
                )}
              </ReviewAfter>
            ) : null}
          </div>
        </div>
      </div>
    </>
  )
}
function ReviewItem({ el, items, idx }: any) {
  const [reviewDday, setReivewDday] = useState<number>()

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (el && el.orderStatusDate) {
      const reviewDate: string = el.orderStatusDate.registerYmdt.split(' ', 1)[0] // 날짜 부분만 추출
      const startDate = new Date(reviewDate)
      startDate.setHours(0, 0, 0, 0) // 자정으로 설정
      const today = new Date()
      today.setHours(0, 0, 0, 0) // 자정으로 설정

      const result = differenceInDays(startDate, today)
      setReivewDday(result)
    }
  }, [el])

  return (
    <div
      className='review_before_box'
      key={el.optionValue}
      style={{
        borderBottom: Number(items.length) === Number(idx + 1) ? 'none' : '8px solid var(--colGray1)',
      }}
    >
      <Link to='' className='review_before_item'>
        <img className='img_box' src={`${el.imageUrl}`} alt='' />
        <div className='txt_box'>
          <p className='brand'>{el.brandName ? el.brandName : '    '}</p>
          <p className='tit'>{el.productName}</p>
          <p className='option'>옵션: {el.optionValue}</p>
          <p className='date'>{`${el.orderStatusDate.registerYmdt
            ?.split(' ', 1)
            .join('')
            .replaceAll('-', '. ')
            .replaceAll('. 0', '. ')} 구매함`}</p>
        </div>
      </Link>
      <a
        href='#'
        className='review_write'
        onClick={(e) => {
          e.preventDefault()
          navigate(`/reviewwrite/${el.productNo}`, {
            state: { path: location.pathname },
          })
        }}
      >
        리뷰 작성하기 <span>(D-{reviewDday})</span>
      </a>
    </div>
  )
}
function MyReviewItem({ el, nickName, setChangeRecommend, item, idx }: any) {
  const [isMore, setIsMore] = useState<boolean>(false)
  const [isLike, setIsLike] = useState<boolean>(true)
  const [isUnLike, setIsUnLike] = useState<boolean>(false)
  const [starCountArray, setStarCountArray] = useState<number[]>([0, 0, 0, 0, 0])
  const [orderYmdt, setOrderYmdt] = useState<string>('')
  const [isReviewModal, setIsReviewModal] = useState(false)
  const reviewSortRef = useRef<any>(null)
  const btnReviewSettingRef = useRef<any>(null)
  const navigate = useNavigate()

  // 모달 외부 클릭시 닫기
  useEffect(() => {
    const handleClickOutside = (e: any) => {
      if (
        reviewSortRef.current &&
        !reviewSortRef.current.contains(e.target) &&
        btnReviewSettingRef.current &&
        !btnReviewSettingRef.current.contains(e.target)
      ) {
        setIsReviewModal(false)
        // setIsSortIcon(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [reviewSortRef])

  useEffect(() => {
    getOrderDetail(el.orderNo).then((res) => {
      setOrderYmdt(res.data.orderYmdt)
    })
  }, [el])

  useEffect(() => {
    getReviewDetail(el.productNo, el.reviewNo)
      .then((res) => {
        setIsLike(res.data.recommendable)
        setIsUnLike(res.data.reportable)
      })
      .catch((err) => console.log(err))
  }, [])

  useEffect(() => {
    getOrderDetail(el.orderNo)
      .then(() => {})
      .catch((err) => console.log(err))
  }, [])

  function recommend(productNo: string, reviewNo: string) {
    postRecommend(productNo, reviewNo)
      .then(() => {
        setChangeRecommend((prev: boolean) => !prev)
      })
      .catch((err) => console.log(err))
  }

  function deleteRecommends(productNo: string, reviewNo: string) {
    deleteRecommend(productNo, reviewNo)
      .then(() => {
        setChangeRecommend((prev: boolean) => !prev)
      })
      .catch((err) => console.log(err))
  }
  return (
    <div
      className='after_box'
      key={el.productNo}
      style={{
        borderBottom: Number(item.length) === Number(idx + 1) ? 'none' : '8px solid var(--colGray1)',
      }}
    >
      <div className='review_before_box'>
        <Link to={`/product/${el.productNo}`} className='review_before_item'>
          <div className='img_box'>
            <div className='dim'></div>
            <img
              src={`${imgURL}/product_bg.png`}
              style={{
                backgroundImage: `url(${el?.imageUrl})`,
              }}
            />
          </div>
          <div className='txt_box'>
            {el?.brandName && <p className='brand'>{el?.brandName}</p>}
            <p className='tit'>{el?.productName}</p>
            <p className='option'>옵션: {el?.orderedOption?.optionValue}</p>
            <p className='date'>
              {orderYmdt?.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ')} 구매함
            </p>
          </div>
        </Link>
      </div>
      <ProductDetailReview>
        <div className='review'>
          <div className='review_txt_wrap'>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                gap: '17px',
              }}
            >
              <p className='star_rating'>
                {starCountArray.map((element: number, idx: number) => {
                  if (idx + 1 <= Math.ceil(el?.rate)) {
                    if (el?.rate - idx === 0.5) {
                      return <img src={`${imgURL}/star_half_off.svg`} alt='별점' key={idx} />
                    } else {
                      return <img src={`${imgURL}/star.svg`} alt='별점' key={idx} />
                    }
                  } else {
                    return <img src={`${imgURL}/star_off.svg`} alt='별점' key={idx} />
                  }
                })}
                <span className='rating_num'>{el?.rate}</span>
              </p>
              <span className='date'>
                {el?.registerYmdt?.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ')}
              </span>
            </div>

            <button
              ref={btnReviewSettingRef}
              className='review_control'
              style={{ position: 'relative' }}
              onClick={() => {
                setIsReviewModal((prev: boolean) => !prev)
              }}
            >
              <img src='/images/icon_plus_circle.svg' alt='' />
              {isReviewModal ? (
                <ReviewSort ref={reviewSortRef}>
                  <div className='sort_layer'>
                    <ul>
                      <li
                        onClick={() => {
                          navigate(`/reviewwrite/${el?.productNo}`, {
                            state: {
                              productNo: el.productNo,
                              reviewNo: el.reviewNo,
                            },
                          })
                        }}
                      >
                        <img src='/images/icon_edit.svg' alt='' />
                        <span>수정하기</span>
                      </li>
                      <li
                        onClick={() => {
                          deleteProductReviews(el?.productNo, el?.reviewNo).then(() => {
                            setChangeRecommend((prev: boolean) => !prev)
                          })
                        }}
                      >
                        <img src='/images/icon_delete2.svg' alt='' />
                        <span>삭제하기</span>
                      </li>
                    </ul>
                  </div>
                </ReviewSort>
              ) : null}
            </button>
          </div>
          <div className='review_contents_wrap'>
            <div className='review_content'>
              {!isMore ? `${el?.content.slice(0, 53)}...` : el?.content}
              {el?.content.length > 53 && !isMore ? (
                <BtnMore
                  style={{
                    fontSize: '16px',
                  }}
                  ismore={isMore.toString()}
                  onClick={() => {
                    setIsMore(!isMore)
                  }}
                >
                  더 보기
                </BtnMore>
              ) : null}
            </div>
            <div className='review_image_wrap'>
              {el.fileUrls?.map((el: string) => {
                return (
                  <div
                    key={el}
                    className='review_img'
                    style={{
                      backgroundImage: `url(${el})`,
                    }}
                  ></div>
                )
              })}
            </div>
            <div className='review_liked'>
              <p>이 리뷰가 도움이 돼요!</p>
              <BtnReviewdLike
                onClick={() => {
                  if (!isLike) {
                    deleteRecommends(el.productNo, el.reviewNo)
                  } else {
                    recommend(el.productNo, el.reviewNo)
                  }
                  setIsLike((prev: boolean) => !prev)
                }}
                islike={`${!isLike}`}
                style={{
                  border: !isLike ? '1px solid transparent' : '1px solid var(--colGray3)',
                }}
              >
                <IconLiked islike={isLike} /> {el.recommendCnt}
              </BtnReviewdLike>
            </div>
          </div>
        </div>
      </ProductDetailReview>
    </div>
  )
}
// 탭 Wrap
export const TabWrap = styled.div`
  width: 100%;
  display: flex;
  @media screen and (min-width: 768px) {
    gap: 20px;
    border-bottom: 1px var(--colGray3) solid;
  }
`
// 상품 상세정보, 리뷰 탭
export const Tab = styled(Button)`
  flex: 1;
  padding: 15px 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--colGray5);
  background: var(--colWhite);
  border-bottom: 1px var(--colGray3) solid;
  & span {
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    color: var(--colPointBlue);
    margin-left: 3px;
  }
  &.on {
    color: var(--colBlack);
    border-bottom: 2px var(--colBlack) solid;
  }
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    flex: none;
    display: flex;
    padding: 16px 2px;
    border-bottom: none;
    & span {
      display: inline-block;
      font-size: 16px;
      font-weight: 500;
      line-height: 18px;
      color: var(--colPointBlue);
      margin-left: 3px;
    }
    &.on {
      position: relative;
      top: 1px;
      font-size: 16px;
      font-weight: 700;
      line-height: 18px;
      color: var(--colBlack);
      border-bottom: 2px var(--colBlack) solid;
    }
    &.on span {
      font-size: 16px;
      font-weight: 700;
      line-height: 18px;
      color: var(--colPointBlue);
    }
  }
`
export const ReviewBefore = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 48px;
  @media screen and (min-width: 768px) {
    padding-bottom: 120px;
  }
`
export const ReviewAfter = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 48px;
  @media screen and (min-width: 768px) {
    padding-bottom: 120px;
  }
`

export const ReviewSort = styled.ul`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  left: 0;
  bottom: 0;
  & .sort_layer {
    position: absolute;
    top: 8.5px;
    right: -16px;
    min-width: 108px;
    border-radius: 8px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.25);
    background: var(--colWhite);
    z-index: 10;
    & ul {
      padding: 12px 16px;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      gap: 12px;
      gap: 24px;
      flex-wrap: wrap;
      & li {
        list-style: none;
        display: flex;
        justify-content: flex-start;
        gap: 4px;
      }
      & li > span {
        display: block;
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        color: var(--colBlack);
      }
      & > li:first-child {
        position: relative;
      }
      & > li::after {
        content: '';
        position: absolute;
        bottom: -12px;
        left: 0;
        right: 0;
        height: 1px;
        width: 100%;
        border-bottom: 1px var(--colGray3) solid;
      }
      & > li:last-child::after {
        display: none;
      }
    }
  }
`

// 상품 리뷰 영역
export const ProductDetailReview = styled.div`
  padding-top: 16px;
  & > .review {
    /* 리뷰 별점, 날짜 wrap */
    & > .review_txt_wrap {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      /* 별점 */
      & > div p.star_rating {
        display: flex;
        align-items: center;
        line-height: 20px;
        position: relative;
        &:after {
          content: '';
          width: 1px;
          height: 12px;
          position: absolute;
          top: 4px;
          right: -8px;
          background: #eaeaea;
        }
        & img {
          width: 14px;
          height: 14px;
        }

        & > span.rating_num {
          font-size: 12px;
          font-weight: 600;
          line-height: 14px;
          color: var(--colBlack);
          margin-left: 4px;
        }
      }
      /* 날짜 */
      & > div .date {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: var(--colGray6);
      }
    }
    /* 리뷰 내용 */
    & > .review_contents_wrap {
      & > .writer {
        font-size: 13px;
        font-weight: 600;
        line-height: 16px;
        color: var(--colBlack);
        margin-bottom: 10px;
      }
      & > p {
        font-size: 13px;
        font-weight: 400;
        line-height: 20px;
        color: var(--colBlack);
      }
      & > div.review_content {
        position: relative;
        white-space: normal;
        overflow: hidden;
        text-align: left;
        word-wrap: break-word;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: var(--colBlack);
        margin-bottom: 10px;
      }
      & > div.review_photo {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
        margin-bottom: 16px;
        overflow-x: auto;
        & > p {
          & img {
            width: 80px;
            height: 80px;
            border-radius: 8px;
            border: 1px var(--colGray3) solid;
            object-fit: cover;
          }
        }
      }
      & > div.review_liked {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
        & > p {
          font-size: 13px;
          font-weight: 400;
          line-height: 16px;
          color: var(--colGray6);
        }
      }
      /* & > p.review_content::after {
        content: '... 더보기';
        width: 50px;
        position: absolute;
        right: 0;
        bottom: 0;
        background-color: tomato;
        display: block;
      } */
    }
  }
  @media screen and (min-width: 768px) {
    & > .review {
      /* 리뷰 별점, 날짜 wrap */
      & > .review_txt_wrap {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        /* 별점 */
        & > div p.star_rating {
          display: flex;
          align-items: center;
          line-height: 20px;
          position: relative;
          &:after {
            content: '';
            width: 1px;
            height: 12px;
            position: absolute;
            top: 4px;
            right: -8px;
            background: #eaeaea;
          }
          & img {
            width: 16px;
            height: 16px;
          }

          & > span.rating_num {
            font-size: 14px;
            font-weight: 600;
            line-height: 16px;
            color: var(--colBlack);
            margin-left: 4px;
          }
        }
        /* 날짜 */
        & > div .date {
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          color: var(--colGray6);
        }
      }
      /* 리뷰 내용 */
      & > .review_contents_wrap {
        & > .writer {
          font-size: 13px;
          font-weight: 600;
          line-height: 16px;
          color: var(--colBlack);
          margin-bottom: 10px;
        }
        & > p {
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          color: var(--colBlack);
        }
        & > div.review_content {
          position: relative;
          white-space: normal;
          overflow: hidden;
          text-align: left;
          word-wrap: break-word;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          color: var(--colBlack);
          margin-bottom: 16px;
        }
        & > div.review_photo {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 8px;
          margin-bottom: 16px;
          overflow-x: auto;
          & > p {
            & img {
              width: 80px;
              height: 80px;
              border-radius: 8px;
              border: 1px var(--colGray3) solid;
              object-fit: cover;
            }
          }
        }
        & > div.review_liked {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 8px;
          & > p {
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            color: var(--colGray6);
          }
        }
        /* & > p.review_content::after {
        content: '... 더보기';
        width: 50px;
        position: absolute;
        right: 0;
        bottom: 0;
        background-color: tomato;
        display: block;
      } */
      }
    }
  }
`

export const NoContentWrap = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

  @media screen and (min-width: 768px) {
    display: flex;
    padding: 0;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
`
export const NoContentCotentWrap2 = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 80px 0 52px 0;
  & img {
    width: 85px;
    height: 85px;
  }
  @media screen and (min-width: 768px) {
    padding: 120px 0 40px 0;
    & img {
      width: 108px;
      height: 108px;
    }
  }
`

export const NoContentContent = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: var(--colGray5);
  text-align: center;
  margin-bottom: 20px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
`
